import { IsLeaderService } from './../../../../core/services/is-leader-service/is-leader.service';
import { AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements AfterViewInit {

  @Input() sku: string;
  @Input() product: any;
  features: any;
  showFeatures: string;
  showMainContent = false;
  hideDescription = false;
  hideCondoFeatures = false;
  hideRealtyFeatures = false;
  public featureProductServices = this.environmentService.getEnvVar('feature_product_services') === 'true';
  @ViewChildren('checkbox') checkboxList: QueryList<ElementRef>;

  constructor(
    private environmentService: EnvironmentService
  ) { }

  ngAfterViewInit() {
    setTimeout(() => {
      this.hideElement();
    }, 500);
  }

  hideElement() {
    const isMobile = document.body.offsetWidth < 768;
    this.features = document.querySelectorAll('.hideable');
    let mobileHeight: number;
    let desktopHeight: number;
    let feature: HTMLElement;
    let button: HTMLElement;

    this.features.forEach(el => {
      feature = document.querySelector('#' + el.id);
      button = document.querySelector('#' + el.id + '+ a');

      switch (feature.nodeName) {
        case 'UL': mobileHeight = 200; desktopHeight = 120; break;
        case 'DIV': mobileHeight = 260; desktopHeight = 78; break;
      }

      if (
        (isMobile && feature.offsetHeight > mobileHeight) ||
        (!isMobile && feature.offsetHeight > desktopHeight)
      ) {
        button.style.display = 'block';
        switch (el.id) {
          case 'realty-description': this.hideDescription = true; break;
          case 'realty-features': this.hideRealtyFeatures = true; break;
          case 'condo-features': this.hideCondoFeatures = true; break;
        }
      }
    });
  }

}
